export const Props = () => ({
  //----------------------------------------------------------------------------
  //                              Уровень заголовка
  //----------------------------------------------------------------------------
  level:{
    type: String,
    default: 'h1',
    validator: (value) => {
      const allowedTypes = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
      if(allowedTypes.includes(value)){
        return true;
      } else{
        throw new Error(` Параметр 'level' может содержать только значения: ${allowedTypes.join(', ')}`);
      }
    }
  }
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});
